import { createContext } from 'react';
import type {
  TConversationsContextValue,
  TConversationThreadContextValue,
} from './Conversations.types.ts';

export const ConversationsContext = createContext<
  TConversationsContextValue | undefined
>(undefined);

export const ConversationThreadContext = createContext<
  TConversationThreadContextValue | undefined
>(undefined);
